import safeCreateAction from "./safeCreateAction";
export const setAttributeVisible = safeCreateAction("SET_ATTRIBUTE_VISIBLE", (tableId, attributeId, visible) => ({
    tableId,
    attributeId,
    visible,
}));
export const setAttributeSort = safeCreateAction("SET_ATTRIBUTE_SORT", (tableId, attributeId, direction) => ({
    tableId,
    attributeId,
    direction,
}));
export const setAttributeFilter = safeCreateAction("SET_ATTRIBUTE_FILTER", (tableId, attributeId, filter) => ({
    tableId,
    attributeId,
    filter,
}));
export const setGroupingAttribute = safeCreateAction("SET_GROUPING_ATTRIBUTE", (tableId, attributeId) => ({ tableId, attributeId }));
export const collapseGroup = safeCreateAction("COLLAPSE_GROUP", (tableId, groupId, collapse) => ({
    tableId,
    groupId,
    collapse,
}));
export const setCollapsedGroups = safeCreateAction("SET_COLLAPSED_GROUPS", (tableId, groups) => ({ tableId, groups }));
